import "../base.js";
import "./slots.js";

window.AppointmentBooking ??= {};
window.AppointmentBooking.SlotPickerModal ??= {};
window.AppointmentBooking.SlotPickerModal.Views ??= {};
window.AppointmentBooking.SlotPickerModal.Views.Calendar ??= {};

AppointmentBooking.SlotPickerModal.Views.Calendar.MonthDays = class MonthDays extends (
  AppointmentBooking.SlotPickerModal.Views.Base
) {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.contextForRender = this.contextForRender.bind(this);
    this.isDayActive = this.isDayActive.bind(this);
    this.makeDayActive = this.makeDayActive.bind(this);
    this.makeDaysInactive = this.makeDaysInactive.bind(this);
    this.showSlotsForDate = this.showSlotsForDate.bind(this);
    this.hideSlots = this.hideSlots.bind(this);
    this.scrollSlotsIntoView = this.scrollSlotsIntoView.bind(this);
    this.dayName = this.dayName.bind(this);
  }

  initialize(options = {}) {
    this.slots = new Backbone.Collection();
    return (this.slotsView = new AppointmentBooking.SlotPickerModal.Views.Calendar.Slots({
      collection: this.slots,
      renderLinks: options.renderLinks,
    }));
  }

  // EVENT HANDLERS

  handleClickDate(event) {
    const dayElement = jQuery(event.currentTarget);

    if (this.isDayActive(dayElement)) {
      this.makeDaysInactive();
      return this.hideSlots();
    } else {
      this.makeDayActive(dayElement);
      this.showSlotsForDate(dayElement.data("date"));
      return this.scrollSlotsIntoView();
    }
  }

  // RENDERING

  contextForRender() {
    const context = super.contextForRender(...arguments);
    const firstDate = moment(this.model.get("calendarDate")).startOf("month").startOf("week");
    const lastDate = moment(this.model.get("calendarDate")).endOf("month").endOf("week");
    const dayNames = [
      this.dayName(firstDate),
      this.dayName(moment(firstDate).add(1, "day")),
      this.dayName(moment(firstDate).add(2, "days")),
      this.dayName(moment(firstDate).add(3, "days")),
      this.dayName(moment(firstDate).add(4, "days")),
      this.dayName(moment(firstDate).add(5, "days")),
      this.dayName(moment(firstDate).add(6, "days")),
    ];

    const days = [];
    let date = firstDate;
    while (date.isSameOrBefore(lastDate)) {
      var day = this.model.get("appointmentGridDates").for(date).toJSON();
      day.focus = __guard__(this.model.get("focusDate"), (x) => x.isSame(date));
      day.currentMonth = __guard__(this.model.get("calendarDate"), (x1) => x1.isSame(date, "month"));
      days.push(day);
      date = moment(date).add(1, "day");
    }

    context.dayNames = dayNames;
    context.days = days;

    return context;
  }

  // HELPER METHODS

  isDayActive(dayElement) {
    return dayElement.hasClass("active");
  }

  makeDayActive(dayElement) {
    this.makeDaysInactive();
    return dayElement.addClass("active");
  }

  makeDaysInactive() {
    return jQuery(".day.active").removeClass("active");
  }

  showSlotsForDate(date) {
    const slots = this.model.get("appointmentGridDates").for(date).get("slots");
    if (!slots.length) {
      return;
    }

    this.slots.reset(slots);
    this.$(`[data-date='${date}']`).closest(".week").after(this.slotsView.el);
    return this.slotsView.el;
  }

  hideSlots() {
    return this.slotsView.$el.detach();
  }

  scrollSlotsIntoView() {
    return this.slotsView.el.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
  }

  // PRIVATE

  dayName(date) {
    return moment.parseZone(date).format("ddd");
  }
};

AppointmentBooking.SlotPickerModal.Views.Calendar.MonthDays.prototype.tagName = "table";
AppointmentBooking.SlotPickerModal.Views.Calendar.MonthDays.prototype.className =
  "appointment-booking-slot-picker-modal-calendar-month-days";
AppointmentBooking.SlotPickerModal.Views.Calendar.MonthDays.prototype.template =
  "appointment_booking/slot_picker_modal/templates/calendar/month_days";
AppointmentBooking.SlotPickerModal.Views.Calendar.MonthDays.prototype.events = {
  'click [data-day-available="true"]': "handleClickDate",
};

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}
